import React, {useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Grid } from '@mui/material'
import SubHeader from 'components/subHeader/SubHeader'
import SubHeaderDetails from 'components/subHeaderDetails/SubHeaderDetails'
import ComplianceDocumentDetails from './ComplianceDocumentDetails'
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb'
import { approveCompliance, getCompliance } from 'redux/actions/UserCompliance'
import { getSubVendor } from 'redux/actions/UserSubVendor';
import { getDriver } from 'redux/actions/UserDriver';
import { getVehicle } from 'redux/actions/UserVehicle';
import Loader from 'components/loader/Loader';

function ComplianceDocument() {
  const dispatch = useDispatch();
  const {state} = useLocation();

  const {id, name, type, vehicleType, submitterId} = state;
  const complianceData = useSelector((state) => state?.userCompliance?.userCompliance?.data) || []
  const loader = useSelector((state) => state?.userCompliance?.loading)
  const vendorData = useSelector((state) => state?.userVendor?.userVendor?.data?.body) || {}
  const loaderSubvendor = useSelector((state) => state?.userSubVendor?.loading)
  const loaderDriver = useSelector((state) => state?.userDriver?.loading)
  const loaderVehcile = useSelector((state) => state?.vehicleData?.loading)
  const loaderVendor = useSelector((state) => state?.useVendor?.loading)
  const subVendorData = useSelector((state) => state?.userSubVendor?.userSubVendor?.data?.body) || {}
  const driverData = useSelector((state) => state?.userDriver?.userDriver?.data?.body) || {}
  const vehicleData = useSelector((state) => state?.userVehicle?.userVehicle?.data) || {}
  const tabDetail = type === 'Vendor' ? vendorData?.length > 0 &&  vendorData[0]: type === 'SubVendor' ? subVendorData?.length > 0 && subVendorData[0] : type === 'Driver' ? driverData?.length > 0 && driverData[0] : vehicleData;
  const complianceLoader = type === 'Vendor' ? loaderVendor : type === 'Driver' ? loaderDriver : type === 'SubVendor' ? loaderSubvendor : loaderVehcile;
  const filterData =  {
    id: id,
    status:"",
    page:"",
    pageSize:"",
    date:'',
    duration:''
  }

  useEffect(() => {
    dispatch(getCompliance(filterData));
    if(type === 'SubVendor'){
      dispatch(getSubVendor({...filterData, subVendorId:submitterId}))
    }else if(type === 'Driver'){
      dispatch(getDriver({...filterData, driverId:submitterId}))
    }else if(type === 'Vehicle'){
      dispatch(getVehicle({vehicleId:submitterId,}))
    }else {
      dispatch(getSubVendor({...filterData, subVendorId:submitterId}))
    }
  }, []);

let value;
switch (state?.type) {
  case 'SubVendor':
    value = 2;
    break;
  case 'Driver':
    value = 3;
    break;
  case 'Vehicle':
    value = 4;
    break;
  default:
    value = 2; // Handle any other cases here
}

  const breadcrumbPaths = [
    { name: 'Compliance', url: `/compliance/${value}`, className: 'colorGrey fontSemi' },
    { name: name, url: '', className: 'colorBlue' },
  ];

  const onClickVerification = (val, data1) => {
    if(data1?.status === 'accepted'){
      let result = val.map(a => a.id);
      const data ={
        acceptanceValues: result,
        status: 'Approved',
        type: type,
        id: id,
      }
      dispatch(approveCompliance(data));
    }else{
      var result = Object.entries(data1).map(([key, value]) => ({rejectionReason:value, id: key}))
      const data = {
        rejectionValues:result,
        status: 'Rejected',
        type: type,
        id: id,
      }
      dispatch(approveCompliance(data));
    }
  }

  return (
    <div className='marginTop'>
       <CommonBreadCrumb paths={breadcrumbPaths}/>
      <Grid container 
        direction="row"
        className="profilevendorMain"
        justifyContent="space-between"
      >
        
       <SubHeader details={tabDetail} type={type} loader={complianceLoader} tabName={'compliance'}/>
       {type !== 'Vehicle' && <SubHeaderDetails details={tabDetail} editIconFalse={true} loader={complianceLoader}/>}
      </Grid>
      {loader? 
        <Loader/> 
        :<ComplianceDocumentDetails details={complianceData} onClickVerification={onClickVerification} /> }
    </div>
  )
}

export default ComplianceDocument
